export function getProjectId(url = null) {
   const pid = /\/project\/(\d+)/g.exec(url ? url : window.location.pathname)
    if (pid) {
        return pid[1]
    }
    return null
}

export function getEshopId() {
    var eshopId = /\/eshop\/(\d+)/g.exec(window.location.pathname)
    return eshopId[1]
}

export function getTemplateId(url = null) {
   const pid = /\/templates\/(\d+)/g.exec(url ? url : window.location.pathname)
    if (pid) {
        return pid[1]
    }
    return null
}

export function getAlternativeTemplateId(url = null) {
   const pid = /\/alternative-templates\/(\d+)/g.exec(url ? url : window.location.pathname)
    if (pid) {
        return pid[1]
    }
    return null
}

export function getFormatId(url = null) {
   const pid = /\/format\/(\d+)/g.exec(url ? url : window.location.pathname)
    if (pid) {
        return pid[1]
    }
    return null
}

export function getFakeProjectId() {
    const match = /\/set-cookie\/(\d+)/g.exec(window.location.pathname)
    return match[1]
}